import React from 'react';

export default function Terms() {
  return (
    <main>
      <div className="page-header">
        <div className="container">
          <h1>이용약관</h1>
          <p>홈페이지 이용에 관한 약관입니다</p>
        </div>
      </div>
      <section className="section">
        <div className="container" style={{ maxWidth: 800 }}>
          <div style={{ lineHeight: 1.9, color: 'var(--gray-700)', fontSize: '0.92rem' }}>
            <h3 style={{ color: 'var(--navy-800)', margin: '1.5rem 0 0.75rem', fontSize: '1.1rem' }}>제1조 (목적)</h3>
            <p>본 약관은 주식회사 허브가 제공하는 홈페이지 서비스 이용과 관련하여 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>
            <h3 style={{ color: 'var(--navy-800)', margin: '1.5rem 0 0.75rem', fontSize: '1.1rem' }}>제2조 (서비스의 제공)</h3>
            <p>회사는 아웃소싱 관련 정보 제공, 온라인 상담 및 채용 지원 서비스를 제공합니다.</p>
            <p style={{ marginTop: '2rem', color: 'var(--gray-500)', fontSize: '0.85rem' }}>
              본 페이지는 샘플 템플릿입니다. 실제 운영 시 법무 검토를 받은 내용으로 교체하시기 바랍니다.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
